export const GET_ORDER_CONFIRM = 'GET_ORDER_CONFIRM';
export const GET_ORDER_CONFIRM_SUCCESS = 'GET_ORDER_CONFIRM_SUCCESS';
export const GET_ORDER_CONFIRM_ERROR = 'GET_ORDER_CONFIRM_ERROR';
export const SET_ORDER_CONFIRM_STATUS = 'SET_ORDER_CONFIRM_STATUS';
export const SET_ORDER_CONFIRM_STATUS_SUCCESS = 'SET_ORDER_CONFIRM_STATUS_SUCCESS';
export const SET_ORDER_CONFIRM_STATUS_ERROR = 'SET_ORDER_CONFIRM_STATUS_ERROR';
export const GET_DOWNLOAD_ORDER_CONFIRM = 'GET_DOWNLOAD_ORDER_CONFIRM';
export const GET_DOWNLOAD_ORDER_CONFIRM_SUCCESS = 'GET_DOWNLOAD_ORDER_CONFIRM_SUCCESS';
export const GET_DOWNLOAD_ORDER_CONFIRM_ERROR = 'GET_DOWNLOAD_ORDER_CONFIRM_ERROR';
export const UPDATE_ORDER_CONFIRM_ITEM = 'UPDATE_ORDER_CONFIRM_ITEM';
